<template>
  <div :class="[$style.notification, $style.coachRequested]">
    <div :class="[$style.main, { [$style.open]: moreDetailsVisible }]">
      <a
        :href="formatUrl(notification.url)"
        :class="$style.header"
        :target="linkTarget"
      >
        <img
          :src="photoUrl(notification.user.photoUrl)"
          :title="notification.user.name"
          alt=""
        />
        <i class="fa fa-star"></i>
        <span>{{ notification.title }}</span>
      </a>
      <span
        v-if="notification.request"
        :class="$style.toggleMoreDetails"
        @click="toggleMoreDetails"
        ><i class="fa fa-angle-left"></i
      ></span>
      <span :class="$style.timer">{{ timer }}</span>
      <div v-if="notification.request" :class="$style.moreDetails">
        <div :class="$style.moreDetailsInner">
          <h5>{{ notification.request.note }}</h5>
          <p :class="$style.moreDetailsBody">
            {{ notification.context }}
            <br />
            at {{ notification.request.time }}
            <a :href="formatUrl(notification.url)" :target="linkTarget"
              ><i class="fa fa-play"></i> listen back</a
            >
          </p>
        </div>
      </div>
    </div>
    <a
      @click.prevent="readNotification(notification)"
      href="#"
      :class="$style.markAsRead"
      data-toggle="tooltip"
      data-placement="left"
      title="mark as read"
    >
      <font-awesome-icon :icon="faTrashAlt" />
    </a>
  </div>
</template>

<script>
import Notification from "./notification";

export default {
  mixins: [Notification],
  data() {
    return {
      moreDetailsVisible: this.notification.request,
    };
  },
};
</script>

<style module lang="less" src="./notification.less"></style>



// WEBPACK FOOTER //
// coach-requested.vue?7b84dc90